/// <reference lib="dom" />
/**
 * The shared WebGL renderer (brief §5.2). Created ONCE by the shell and passed
 * to every game view — repeated context creation is badly handled on iOS
 * Safari, and a shared renderer makes the A/B switch instant.
 *
 * GLOBAL SETTINGS ARE FIXED HERE AND NOWHERE ELSE:
 *   colour space  : SRGBColorSpace output
 *   tone mapping  : ACESFilmic, exposure 1.0
 *   antialias     : true
 *   shadow maps   : DISABLED globally — games fake contact shadows with
 *                   gradient sprites; no view may enable renderer.shadowMap
 *   powerPreference: high-performance
 *
 * Views must leave renderer state as found (renderer.resetState() on destroy).
 */

import * as THREE from 'three';
import type { QualityTier } from '@hnplay/shared';

export function createSharedRenderer(canvas: HTMLCanvasElement, tier: QualityTier): THREE.WebGLRenderer {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    alpha: false,
    powerPreference: 'high-performance',
    stencil: false,
  });
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.shadowMap.enabled = false;
  renderer.setPixelRatio(pixelRatioForTier(tier));
  return renderer;
}

export function pixelRatioForTier(tier: QualityTier): number {
  const dpr = typeof devicePixelRatio === 'number' ? devicePixelRatio : 1;
  if (tier === 'low') return 1;
  if (tier === 'medium') return Math.min(dpr, 1.5);
  return Math.min(dpr, 2);
}